"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionCodeUsedCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class PromotionCodeUsedCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackPromotionCodeUsedEvent(this.input);
    }
}
exports.PromotionCodeUsedCommand = PromotionCodeUsedCommand;
